import HeaderRegister from "../../../../components/header/register";
import FormStoreLogo from "../form";

const MainRegisterStoreLogo = () => {
	const options = {
		title: "Logo e Identidade Visual",
		subTitle: "Configuração",
	};

	return (
		<div className="mt-page">
			<HeaderRegister title={options.title} subTitle={options.subTitle} />
			<FormStoreLogo />
		</div>
	);
};

export default MainRegisterStoreLogo;
